import type { ReactNode } from "react";
import { Checkbox, Modal } from "antd";
import "../common/H5PromptModal.css";
import "./LegalAgreePromptModal.css";

type Props = {
  open: boolean;
  title?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
  confirmText?: string;
  children: ReactNode;
};

export function LegalAgreePromptModal(props: Props) {
  const {
    open,
    title = "请阅读并同意相关协议",
    checked,
    onCheckedChange,
    onCancel,
    onConfirm,
    confirmText = "同意并继续",
    children,
  } = props;

  return (
    <Modal
      className="lf-h5-prompt-modal legal-agree-prompt"
      title={null}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={320}
      centered
      closable
      maskClosable
      destroyOnClose
      zIndex={1100}
    >
      <div className="lf-h5-prompt-modal__body lf-h5-prompt-modal__body--left legal-agree-prompt__body">
        <p className="lf-h5-prompt-modal__title legal-agree-prompt__title">{title}</p>
        <Checkbox
          className="legal-agree-prompt-check"
          checked={checked}
          onChange={(e) => onCheckedChange(e.target.checked)}
        >
          {children}
        </Checkbox>
      </div>
      <div className="lf-h5-prompt-modal__actions">
        <button
          type="button"
          className="lf-h5-prompt-modal__btn lf-h5-prompt-modal__btn--ghost"
          onClick={onCancel}
        >
          取消
        </button>
        <button
          type="button"
          className="lf-h5-prompt-modal__btn lf-h5-prompt-modal__btn--primary"
          onClick={onConfirm}
        >
          {confirmText}
        </button>
      </div>
    </Modal>
  );
}
